import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '../lib/utils';

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        primary:
          'bg-blue-700 text-blue-100!  hover:bg-blue-900 dark:bg-blue-500 dark:text-blue-100 dark:hover:bg-blue-700 rounded-md ',
        secondary:
          'bg-transparent  border-2 border-blue-700 hover:bg-blue-200 rounded-md  text-blue-700 dark:text-blue-500 dark:hover:bg-blue-900',
        tertiary:
          'bg-transparent [&>div>p]:underline text-blue-700 dark:text-blue-500 hover:text-blue-900 hover:dark:text-blue-300',
        outlined:
          'bg-transparent border dark:bg-border-blue-500 dark:bg-text-blue-500  border-blue-500 text-blue-500 rounded-full hover:dark:bg-blue-900 ',
        danger: 'bg-red-700 text-white hover:bg-red-900 rounded-md dark:bg-red-500 dark:hover:bg-red-700',
        'danger-secondary':
          'bg-transparent text-red-700   border-2 border-red-700  hover:bg-red-200 rounded-md dark:text-red-500 dark:border-red-500 dark:hover:bg-red-1000',
        minimal: 'bg-transparent text-blue-900 hover:bg-blue-200 cursor-pointer dark:text-blue-100 dark:hover:bg-blue-900',
      },
      size: {
        sm: 'py-1 px-2 [&>div>p]:text-sm [&>div>span]:text-xl ',
        md: 'py-2 px-4 text-base max-h-12',

        lg: 'py-3 px-8 text-lg ',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  }
);

function Button({
  className,
  variant,
  size,
  asChild = false,
  ...props
}: React.ComponentProps<'button'> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean;
  }) {
  const Comp = asChild ? Slot : 'button';

  return (
    <Comp
      data-slot="button"
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    />
  );
}

export { Button, buttonVariants };
